import enums from '../utils/enums';
import { APP } from '../utils/constants';
import store from '../store';

import { getItem, setItem, clearStore, removeItem } from './storage';

export const getToken = () => {
  return getItem('token');
};

export const setToken = (token, { keepLogged = false } = {}) => {
  setItem('token', token, {
    session: !keepLogged
  });
};

export const getTicketCrmToken = () => {
  return getItem('octa-token');
};

export const setTicketCrmToken = token => {
  setItem('octa-token', token);
};

export const getOctaUsers = () => {
  return getItem('octa-users');
};

export const setOctaUsers = users => {
  setItem('octa-users', users);
};

export const getAdminPreview = () => {
  return getItem('adminPreview');
};

export const setAdminPreview = admin => {
  setItem('adminPreview', JSON.stringify(admin), {
    session: true
  });
  store.commit(APP.MUTATE_ADMIN_PREVIEW, admin);
};

export const removeAdminPreview = () => {
  removeItem('adminPreview');
  removeItem('token');
  store.commit(APP.MUTATE_ADMIN_PREVIEW, null);
};

export const setAccessType = accessType => {
  setItem('accessType', accessType, {
    session: true
  });
};

export const getAccessType = ({ ignoreDefault = false } = {}) => {
  return (
    getItem('accessType') ||
    (ignoreDefault ? null : enums.accessTypes.continuedSession)
  );
};

export const logout = () => {
  const token = getToken();
  removeAdminPreview();

  clearStore();
  if (token) {
    location.reload();
  }
};

export const getDuplicatedEmail = () => {
  return getItem('duplicatedEmail');
};

export const setDuplicatedEmail = (value = false) => {
  setItem('duplicatedEmail', value);
};



// WEBPACK FOOTER //
// ./src/services/auth.js